export default class EndPointProvider{
    static getEndPoint(){
        return process.env.REACT_APP_API_URL;
    }
    
    static getAirtableEndPoint() {
        return process.env.REACT_APP_AIRTABLE_URL;
    }
}